import { render, staticRenderFns } from "./ArticleHomeList.vue?vue&type=template&id=2c6508f6"
import script from "./ArticleHomeList.vue?vue&type=script&lang=js"
export * from "./ArticleHomeList.vue?vue&type=script&lang=js"
import style0 from "./ArticleHomeList.vue?vue&type=style&index=0&id=2c6508f6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports